export const InlineHelpStyles = () => {
    return {
        "& .inline-help": {
            borderTop: "1px solid #130b38",
            fontSize: "12px",
            padding: "10px",
        },
        "& .inline-help label": {
            color: "#ffffff"
        },

        "& .inline-help__definition": {
            backgroundColor: "#ffffff",
            marginTop: "10px",
            padding: "10px 8px",
            position: "relative"
        },
        "& .inline-help__definition::before": {
            content: '""',
            display: "block",
            border: "8px solid",
            borderColor: "transparent",
            borderBottomColor: "#ffffff",
            width: "8px",
            position: "absolute",
            top: "-16px",
        },
        "& .inline-help .form-select": {
            minWidth: "auto"
        }
    }
}